import ActionTypes from '../constants/ActionTypes';
import { State } from '../reducers';

export function isSiteLoaded(state: State, key) {
  return !!(state.sites.status[key] && state.sites.status[key] === ActionTypes.FETCH_SITE_SUCCESS);
}

export function getSiteStatusByKey(state: State, key) {
  return state.sites.status[key];
}

export function getSiteByKey(state: State, key) {
  return state.sites.list[key];
}

export function getSiteRatings(state: State, key) {
  const site = getSiteByKey(state, key);
  if (!site) return null;
  return site.rating;
}
